export function sendOrderAjax(data, cb, errorCb) {
    $.ajax({
        url: "",
        type: "POST",
        dataType: "json",
        data: data,
        success: cb
    });
}